export default __webpack_public_path__ + "static/media/dieppe14.71440a16.jpg";